import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-attendance',
  standalone: true,
  templateUrl: './edit-attendance.component.html',
  styleUrl: './edit-attendance.component.css',
})
export class EditAttendanceComponent {}
